import React from 'react';
import SecuritySection from './ui/SecuritySection';
import { IconAlert } from '../../ui/adminIcons';

export default function SecurityAlertsPanel({
  dashboardData,
  protectionStats,
  onReviewCritical,
  onViewHighRisk,
}) {
  const hasCritical = dashboardData.severityCounts?.CRITICAL > 0;
  const hasBlocked = dashboardData.blockedIPs?.length > 0;
  const hasHighRisk = protectionStats.riskScoring.highRiskIPs > 0;

  if (!hasCritical && !hasBlocked && !hasHighRisk) return null;

  return (
    <SecuritySection title="Critical alerts" icon={<IconAlert />}>
      <div className="vx-sec-alerts">
        {hasCritical ? (
          <div className="vx-sec-alert vx-sec-alert--critical">
            <h3 className="vx-sec-alert-title">Critical threats detected</h3>
            <p className="vx-sec-alert-body">
              {dashboardData.severityCounts.CRITICAL} critical security events require immediate attention.
            </p>
            <button type="button" className="btn vx-sec-alert-action" onClick={onReviewCritical}>
              Review events
            </button>
          </div>
        ) : null}

        {hasBlocked ? (
          <div className="vx-sec-alert vx-sec-alert--warning">
            <h3 className="vx-sec-alert-title">IPs currently blocked</h3>
            <p className="vx-sec-alert-body">
              {dashboardData.blockedIPs.length} IP addresses are currently blocked by the security system.
            </p>
            <div className="vx-sec-ip-badges">
              {dashboardData.blockedIPs.slice(0, 3).map((ip) => (
                <span key={ip} className="vx-sec-ip-badge">{ip}</span>
              ))}
              {dashboardData.blockedIPs.length > 3 ? (
                <span className="vx-sec-ip-badge-more">+{dashboardData.blockedIPs.length - 3} more</span>
              ) : null}
            </div>
          </div>
        ) : null}

        {hasHighRisk ? (
          <div className="vx-sec-alert vx-sec-alert--info">
            <h3 className="vx-sec-alert-title">High-risk IPs detected</h3>
            <p className="vx-sec-alert-body">
              {protectionStats.riskScoring.highRiskIPs} IP addresses show suspicious behavioral patterns.
            </p>
            <button type="button" className="btn vx-sec-alert-action" onClick={onViewHighRisk}>
              View analysis
            </button>
          </div>
        ) : null}
      </div>
    </SecuritySection>
  );
}
